import { Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import EditButton from './EditButton';

const BoxItem = styled(Box)(() => ({
  display: 'flex',
  flexGrow: 1,
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
}));

const GenVehicleDetails = ({
  vehicle,
  children,
  image,
  showEdit,
  onClickEdit,
}) => {
  const { t } = useTranslation('global');

  return (
    <>
      <Stack gap={2} px={{ xs: 0, md: 2 }}>
        {showEdit && (
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="overline">{t('vehicleDetails')}:</Typography>
            <EditButton onClickEdit={onClickEdit} />
          </Stack>
        )}
        <Box display="flex">
          <Box
            display="flex"
            flexGrow={2}
            flexDirection="row"
            alignItems="center"
          >
            {image && (
              <img
                component="img"
                style={{ width: '151px', height: 'auto', marginRight: '1rem' }}
                src={image}
                alt="Car reference"
              />
            )}
            <BoxItem>
              <Box
                flexGrow={1}
                overflow="hidden"
                flexBasis={{ xs: '50%', md: '37%' }}
                order={1}
                display={{ xs: 'flex', md: 'unset' }}
                gap={1}
                alignItems="center"
              >
                <Typography variant={'subtitle2'}>{t('vin')}:</Typography>
                <Typography
                  overflow="hidden"
                  textOverflow="ellipsis"
                  variant="body1"
                >
                  {vehicle.vin}
                </Typography>
              </Box>
              <Box
                flexGrow={1}
                flexBasis={{ xs: '50%', md: '21%' }}
                order={{ xs: 7, md: 2 }}
                display={{ xs: 'flex', md: 'unset' }}
                gap={1}
                alignItems="center"
              >
                <Typography variant={'subtitle2'}>{t('make')}:</Typography>
                <Typography variant="body1">{vehicle.make}</Typography>
              </Box>
              <Box
                flexGrow={1}
                flexBasis={{ xs: '50%', md: '21%' }}
                order={{ xs: 2, md: 3 }}
                display={{ xs: 'flex', md: 'unset' }}
                gap={1}
                alignItems="center"
              >
                <Typography variant={'subtitle2'}>{t('year')}:</Typography>
                <Typography variant="body1">{vehicle.year || '-'}</Typography>
              </Box>
              <Box
                flexGrow={1}
                flexBasis={{ xs: '50%', md: '21%' }}
                order={{ xs: 8, md: 4 }}
                display={{ xs: 'flex', md: 'unset' }}
                gap={1}
                alignItems="center"
              >
                <Typography variant={'subtitle2'}>{t('ro')}:</Typography>
                <Typography variant={'body1'}>{vehicle.ro || '-'}</Typography>
              </Box>
              <Box
                flexGrow={1}
                flexBasis={{ xs: '50%', md: '37%' }}
                order={{ xs: 4, md: 6 }}
                display={{ xs: 'flex', md: 'unset' }}
                gap={1}
                alignItems="center"
              >
                <Typography variant={'subtitle2'}>{t('stock')}:</Typography>
                <Typography variant="body1">
                  {vehicle.custody?.stockNumber}
                </Typography>
              </Box>
              <Box
                flexGrow={1}
                flexBasis={{ xs: '50%', md: '21%' }}
                order={{ xs: 10, md: 7 }}
                display={{ xs: 'flex', md: 'unset' }}
                gap={1}
                alignItems="center"
              >
                <Typography variant={'subtitle2'}>{t('model')}:</Typography>
                <Typography variant="body1">{vehicle.model || '-'}</Typography>
              </Box>
              <Box
                flexGrow={1}
                flexBasis={{ xs: '50%', md: '21%' }}
                order={{ xs: 5, md: 8 }}
                display={{ xs: 'flex', md: 'unset' }}
                gap={1}
                alignItems="center"
              >
                <Typography variant={'subtitle2'}>{t('color')}:</Typography>
                <Typography variant="body1">{vehicle.color || '-'}</Typography>
              </Box>
              <Box
                flexGrow={1}
                flexBasis={{ xs: '50%', md: '21%' }}
                order={{ xs: 11, md: 9 }}
                display={{ xs: 'flex', md: 'unset' }}
                gap={1}
                alignItems="center"
              >
                <Typography variant={'subtitle2'}>{t('po')}:</Typography>
                <Typography variant="body1">{vehicle.po || '-'}</Typography>
              </Box>
              <Box
                flexBasis="100%"
                height={{ xs: 6, md: 25 }}
                order={{ xs: 3, md: 5 }}
              ></Box>
              <Box
                flexBasis="100%"
                display={{ xs: 'box', md: 'none' }}
                height={6}
                order={6}
              ></Box>
              <Box
                flexBasis="100%"
                display={{ xs: 'box', md: 'none' }}
                height={6}
                order={9}
              ></Box>
            </BoxItem>
          </Box>
          {children && (
            <Box flexGrow={1} display="flex" gap={3}>
              {children}
            </Box>
          )}
        </Box>
      </Stack>
    </>
  );
};

export default GenVehicleDetails;
